'use strict';

(function () {
  'use strict';

  angular.module('vnext').controller('HomepageCtrl', HomepageCtrl);

  HomepageCtrl.$inject = ['httpSvc', 'trainSvc', 'inspirationSvc', 'activityRouter', 'memberMessagesSvc', 'internalLinkSvc', 'imageMapSvc', '$window', 'eventTrackingSvc', 'appMode', '$rootScope'];

  /* @ngInject */
  function HomepageCtrl(httpSvc, trainSvc, inspirationSvc, activityRouter, memberMessagesSvc, internalLinkSvc, imageMapSvc, $window, eventTrackingSvc, appMode, $rootScope) {
    var vm = this;
    vm.title = 'HomepageCtrl';
    vm.startTrain = activityRouter.startTrain;
    vm.createTrain = activityRouter.createTrain;
    vm.sendMemberMessageEvent = sendMemberMessageEvent;

    vm.promotions = null;
    vm.notification = null;
    vm.notificationLink = null;

    vm.appMode = appMode || 'STANDARD';
    vm.isHideSleepSection = $rootScope.sleepSectionConfiguration ? $rootScope.sleepSectionConfiguration[vm.appMode] : false;
    var _inspirationsGridColumn = vm.appMode === 'STANDARD' ? 6 : 4;

    activate();
    ////////////////

    function activate() {
      trainSvc.getTrain().then(function (train) {
        vm.responseStatus = train.status;
      });
      var tag = ['core:popular'],
          context = 'CORE',
          size = 20;
      httpSvc.get('/apiproxy/user/activities/search/tags/?tag=' + tag + '&context=' + context + '&size=' + size).then(function (dat) {
        vm.activities = dat;
      });
      inspirationSvc.getNextPage('new', _inspirationsGridColumn, true).then(function (inspirations) {
        vm.inspirations = inspirations;
      });
      if ($window.MYSTRENGTH.config.platforms && $window.MYSTRENGTH.config.platforms.web && $window.MYSTRENGTH.config.platforms.web.features && $window.MYSTRENGTH.config.platforms.web.features.member_messages === true) {
        vm.memberMessagesActive = true;
        getMessages();
      }
    }

    function sendMemberMessageEvent($event, internalLinkUrl, type, id) {
      eventTrackingSvc.sendLinkClickEventAndNavigate($event, internalLinkUrl, {
        category: 'member_messages',
        action: type,
        value: id
      });
    }

    function getMessages() {
      memberMessagesSvc.getMessages().then(function (messages) {
        vm.promotions = messages.promotions;
        vm.notification = messages.notification;
        if (!_.isEmpty(vm.notification) && !_.isEmpty(vm.notification.destination)) {
          vm.notificationLink = internalLinkSvc.getInternalLink(vm.notification.destination);
        }
        if (!_.isEmpty(vm.promotions)) {
          _.map(vm.promotions, function (promotion) {
            promotion.internalLink = internalLinkSvc.getInternalLink(promotion.destination);
            promotion.imageUrl = imageMapSvc.getImageSrc(promotion);
          });
        }
      });
    }

    vm.isNotificationEmpty = function () {
      return _.isEmpty(vm.notification);
    };
  }
})();